import { render, staticRenderFns } from "./MainLeftpart.vue?vue&type=template&id=e8950c98&scoped=true"
import script from "./MainLeftpart.vue?vue&type=script&lang=js"
export * from "./MainLeftpart.vue?vue&type=script&lang=js"
import style0 from "./MainLeftpart.vue?vue&type=style&index=0&id=e8950c98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8950c98",
  null
  
)

export default component.exports